import React from 'react'
import classNames from 'classnames'
import { Subtitle } from 'components/base/Text'
import PlaceholderImg from './Placeholder.svg'

export default function ListPlaceholder() {
  return (
    <div
      className={classNames(
        'activity-row',
        'margin-left-auto margin-right-auto',
        'padding-large'
      )}
    >
      <div className="center-text margin-top-huge">
        <Subtitle>
          Oops, seems like your team hasn’t been very active lately
        </Subtitle>
        <div className="font-family-system font-weight-medium margin-bottom-huge shade-10">
          Bring the missing pieces and get your team members back on track
        </div>
        <img src={PlaceholderImg} alt="" />
      </div>
    </div>
  )
}
